import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import languages from "languages/languages";
import { mainRequest } from "api";
import { METHOD, mainApiPath } from "api/constants";
import { ReactComponent as LogoErrors } from "assets/images/erros-logo.svg";
import styles from "./NetworkError.module.css";

const NetworkError = () => {
  const langState = useSelector((state) => state.language.lang);
  const titleError = languages[langState]["ôi không"];
  const contentError =
    languages[langState]["Kết nối mạng đang gặp vấn đề.Vui lòng thử lại sau"];
  const titleButton = languages[langState]["thử lại"];
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(true);

  const checkNetwork = async () => {
    const { get } = METHOD;
    setLoading(true);
    try {
      const response = await mainRequest(
        mainApiPath.codeList,
        { lang: langState },
        get
      );
      const data = await response.data;
      if (data) {
        setLoading(false);
        setError(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const handleRetry = () => {
    checkNetwork();
  };

  useEffect(() => {
    if (!error) {
      history.go(0);
    }
  }, [error]);

  return (
    <div className={styles.wrappError}>
      <div className={styles.errorsContainer}>
        <div className={styles.errorIcon}>
          <LogoErrors />
        </div>
        <div className={styles.errorContent}>
          <h2 className={styles.errorTitle}>{titleError}</h2>
          <div className={styles.errorDesc}>{contentError}</div>
          <button onClick={handleRetry}>{titleButton}</button>
        </div>
      </div>
    </div>
  );
};

export default NetworkError;
